// extracted by mini-css-extract-plugin
export default {"iconStickers":"IconStickers_iconStickers__Fzd-B"};